
import OrderchampLogo from '@marketplace/components/shared/icons/OrderchampLogo.vue'
import TicaOrderchampLogo from '@marketplace/components/shared/icons/TicaOrderchampLogo.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'HeaderSignUp',

    components: {
        OrderchampLogo,
        TicaOrderchampLogo,
    },

    computed: {
        ...mapGetters('global', ['account', 'showTicaLogo']),
    },
}
